const message = {
    company: "Company",
    department: "Department",
    directorate: "Directorate",
    division: "Division",
    employee: "Employee",
    functional: "Functional",
    grade: "Grade",
    jobStatus: "Job Status",    
    lookup: "Lookup",
    position: "Position",
    section: "Section",
    superior: "Approval (Superior)",
    unit: "Unit",
    user:"User",
    group: "Group",
    menu: "Menu",
    role: "Role",
    business: "Business",
    region: "Region",
    active: "Active",
    name6up: "Name (Grade 6Up)",
    fortable: "Fortable",
    rank: "Rank",
    birthdate: "Birth Date",
    workdate: "Work Begin",
    superior1: "Superior",
    nik_superior1: "NIK Superior",    
    superior2: "Head Superior",
    nik_superior2: "NIK Head Superior",    
    pic: "PIC Name",
    inactive_account: "This Account has been inactive",
    receive_notification: "Receive Notification",
    appraisal_year: "Appraisal Year",
    appraisal: "Appraisal",
    employee_data: "Employee Data",
    emp_name: "Employee Name",
    EPA: "Employee Performance Assessment",
    warning_letter_period: "SP / Period",
    appraisal_period: "Appraisal Period",
    comment_review: "Reviewer comments",
    company_name: "Company Name",
    company_desc: "Full Company Name",    
    dept_name: "Department Name",
    directorate_name: "Directorate Name",
    division_name: "Division Name",
    functional_name: "Functional Name",
    business_unit: "Business Unit",
    ou_name: "OU Name",
    region_code: "Region Code",
    period_History: "Period Year",
    cut_off: "Cut Off",
    valid_from: "Valid From",
    valid_to: "Valid To",
    semester: "Semester",   
    pembobotan: "On Rating",
    rating: "Rating",
    total_score: "Total Score",
    objective: "Objective and Indicator",
    achieve: "Achievement",
    evaluate: "Evaluation & Feedback",
    point: "Point",
    job_status_name: "Job Status Name",
    section_name: "Section Name",    
    position_name: "Position Name",
    s_edit: "Edit By Superior",
    s_date: "Edit Date Superior",    
    h_edit: "Edit By H. Superior",
    h_date: "Edit Date H. Superior",        
    company_all: "All Company",
    functional_all: "All Functional",
    grade_all: "All Grade",
    unit_all: "All Unit",    
    warning_letter: "SP (Warning Letter)",   
    status_sp: "SP Status",
    period_sp: "Period (SP Begin Date)",    
    appraisal_reset: "Appraisal Data (Appraisal Reset)",    
    input_by: "Input By (User)",
    input_date: "Date Input (User)",
    edit1_by: "Edit By (Superior)",
    edit1_date: "Edit Date (Superior)",
    edit2_by: "Edit By (Head Superior)",
    edit2_date: "Edit Date (Head Superior)",
    edit3_by: "Edit By (Komite)",
    edit3_date: "Edit Date (Komite)",  
    emp_number: "Username",
    code: "Code",
    description: "Description",    
    nik: "NIK",
    name: "Name",
    created_by: "Creation By",
    created_date: "Creation Date",
    request_by : "Request By",
    request_date : "Request Date",
    edited_by: "Edit By",
    edited_date: "Edit Date",
    deleted_by: "Deletion By",
    deleted_date: "Deletion Date",    
    is_deleted: "Deleted",
    rate: "Rate",
    period: "Period",
    periodTo : "Period To",
    periodFrom : "Period From",
    action: "Action",
    reset_confirmation: "Reset Confirmation",    
    promot_confirmation: "Confirmation of Promotion",
    review_confirmation: "Review Confirmation",    
    assesed_appraisal: "List of employees who have been assessed (Appraisal)",
    not_assesed_appraisal: "List of employees who have not been assessed (Appraisal)",
    changelog: "Changelog",
    email: "Email",
    username: "Username",
    full_name: "Name",
    account: "Account",
    is_required: "Value is required",
    year: "Year",
    create: "Create",
    password: "Password",
    log_history: "Assessment Activity Log (History)",
    lookup_group: "Lookup Group",
    lookup_key: "Lookup Key",
    lookup_value: "Lookup Value",
    lookup_info1: "Info 1",
    lookup_info2: "Info 2", 
    version: "Version",
    version_date: "Version Date",
    remark: "Remark",
    version_active: "Version Active",
    report_type: "Report Type",
    ChangeOnTransaction : "Change On Transaction ?",
    userExc: "User Exclusion",
    clear: "Clear",
    download_supporting_data: "Download Supporting Data",
    use_ad: "Use AD",
    create_appraisal_notice: "To create new appraisal data,",
    click_here: "Click here",
    criteria: "Criteria",   
    range: "Range",
    standard: "Standard",
    summary: "Summary",
    grade_begin: "Grade Begin",
    education: "Education",
    source: "Source",
    structure: "Structure Description",
    promotion_data: "Promotion Data",
    promotion_request: "Promotion Request",
    tolerance_up: "Tolerance Up",
    tolerance_down: "Tolerance Down",    
    promotion_status: "Promotion Request",    
    sync_confirmation: "Sync Confirmation",
    score: "Score",
    status: "Status",   
    lengthWork: "Length of Service",
    lengthGrade: "Grade Period",    
    requested_date: "Requested Date",
    requested_by: "Requested By",
    hrr: "HRR/PGA Head",
    effective_date: "Effective Date",
    reason: "Reason",
    new_position: "New Position",
    reason_promot: "Reason Promotion",
    information: "Information",
    promotion: "Promotion",
    performance_period: "Periode Kinerja", 
    nik_length: "NIK must consist of at least 8 digits",    
    sap_result_success: "of the total employees synced successfully",
    sap_result_failed: "of the total employees failed to sync",
    user_level : "User Level",
    job_position : "Job Position", 
    contact : "Contact",    
    digital_sign : "Digital Sign",
    contractor : "Contractor",
    release_matrix : "Release Matrix",  
    location : "Location",
    validity : "Validity",
    type : "Type",
    category : 'Category',
    info1 : "Info 1",
    info2 : "Info 2",
    approval_as : "Approval As",
    level : "Level",    
    module : "Module",
    budget_allocation : "Budget Allocation",
    job_postion : "Job Position",
    approval : "Approval",
    company_contractor : "Company Contractor",
    last_approval_by : "Last Approval By",
    last_approval_date : "Last Approval Date",      
    approval_confirmation : "Approval Confirmation", 
    contact_number : "Contact Number",   
    approval_by : "Approval By",
    approval_date : "Approval Date",
    area : "Area",
    cost_center : "WBS Allocation",
    previous_process : "Last Process Document",
    approve : "Approve",
    reject : "Reject",
    revisi : "Revise",            
    release_approval : "Release Approval",
    adress : "Address",
    service_type : "Service Type",
    logo_contractor : "Logo Contractor",
    approval_master_data : "Approval Master Data",
    maindata : "Main Data",
    no_wo : "WO Number",
    no_spo : "No SPO",
    job_desc : "Job Description",
    no_spr :"No SPR",
    no_spk : "No SPK",
    contract_value : "Contract Value",
    budget :"WBS Allocation",
    nilai_estimasi : "Estimated  Value",
    tanggal_mulai : "Start Date",
    periode_kerja : "Working Period",
    no : "No",
    doc_type:"Document Type",
    process : "Process",
    keterangan :"Information",
    doc_date : "Document Date",
    doc_no : "Document No",
    spo_date : "SPO Date",
    tanggal_mulai_pekerjaan : "Job Start Date",
    job_completion_time : "Job Completion Time",
    pic_pm : "PIC Project Manager",
    pic_contractor : "PIC Contractor",
    pic_cp : "PIC Coordinator Project",
    scope : "Scope",
    all_company : "All Company",
    project : "Projek",
    meeting_no : "Meeting No ",
    date_of_meeting : "Date Of Meeting",
    meeting_room : "Meeting Room",
    documentation : "Documentation",
    notes_issued_by : "Notes Issued By",
    notes : "Notes",
    is_check : "Check",
    approved_by : "Approved By",
    issued_date : "Issued Date",
    item : "Item",
    company_wilmar : "Company Wilmar",
    description_discussions : "Description Discussions",
    dept : "Dept",
    job_role : "Job Role",
    sign: "Sign",
    action_by : "Action By",
    date_action_required : "Date Action Required",
    user_type : "User Type",
    site_manager : "Site Manager",
    count_day :"Number of Days",
    day_date :  "Day/Date",
    end_date : "Date of Completion of SPO/SPK",
    final_date : "QC Inspection Final Date",
    count_delay_day : "Number of Days of Delay", 
    result : "Result", 
    start_date : "Start Date",
    date_end : "End Date",
    day : "Day",
    final_day1: "Final Day",   
    subject : "Subject",
    attachment : "Attachments",
    penalty_value : "Penalty Value",
    date_place: "Place, date month  year",
    issued_by: "Issued By",
    cp_pm : "Coordinator Project/ Project Manager",
    title_of_work:"Title Of Work",
    spo: "SPO",
    job_title : "Job Title",
    value : "Value",
    work : "Work",
    contract_no: "Contract No",
    initial_actual_percentage: "Initial Actual Percentage",
    persentase_pp: "Additional/Deducation Percentage",
    initial_value_contract: "Initial Contract Amount",
    nilai_pp: "Amount",
    final_value_contract: "Actual Contract Amount (Rounding)",
    admin_pic: "PIC Admin Project",
    head_unit: "PIC Head Unit",
    type_Persentase : "Percentage Type",
    type_nilai : "Value Type",
    print : "Print",
    cek_all : "Cek All",
    task : "Task",
    sch_date : "Sch Date",
    act_date : "Act Date",
    remarks : "Remarks",
    completion_time :"Completion Time",
    tgl_penerimaan : "Received Date",
    accept_pekerjaan : "Work Status",
    tgl_spo : "SPO Date",
    all_location : "All Location",
    date : "Date",
    currently: "Currently",
    previously : "Previously",
    inspection : "Inspection",
    issue : "Issue",
    rectification: "Rectification",
    date_time : "Date/Time",
    area_plant: "Area Plant",
    report_number : "Report Number",
    inspector : "Inspector",
    contractor_title : "Contract Title",
    accept_repair : "QC Status",
    days: "Days",
    comments : "Comments",
    date_Of_sign :"Date Of Sign",
    project_qc : "Project Quality Control",
    project_qc_head: "Project QC Head",
    request_date : "Request Date",
    approval_transaction : "Approval Transaction",
    type_spo : "Type SPO",
    baik_spo : "BAIK with SPO",
    baik : "BAIK with out SPO",
    kom : "Doc Kom",
    delay : "BA Delay",
    penalty : "BA Penalty",
    addendum : "Addendum",
    basttermin : "BAST Termin",
    qc : "Doc Qc Final",
    bastfinal:"BAST Final",
    from : "From",
    to : "To",
    from_date : "From Date",
    to_date : "To Date",
    is_urgent_main_data : "w/o SPO",
    download_currently : "Download Currently",
    download_inspection : "Download Inspection",
    format_email :"Invalid Format Email",
    view : "View",
    edit : "Edit",
    delete : "Delete",
    month : "Month",
    inspection_previosly : "Inspection Previously",
    inspection_currently : "Inspection Currently",
    company_code : "Company Code",
    recitified_day : "Rectified Day(s)",
    percent : "Percent",
    tanggal_selesai : "End Date",
    rev_addendum : "Rev Addendum",
    rev_final : "Rev Final",
    rev_spo : "Rev BAIK SPO",
    rev_baik : "Rev BAIK",
    rev_kom : "Rev Doc KOM",
    rev_delay : "Rev Delay",
    rev_penalty : "Rev Penalty",
    rev_termin : "Rev Termin", 
    rev_qc : "Rev QC",
    rev : "Rev",
    count_day_penalty:"Number Of Days Penalty",
    child_termin : "Sub BAST Termin", 
    child_BAIK_SPO : "Sub BAIK with SPO",
    child_KOM : "Sub Kick Off Meeting",
    child_Progress_Termin : "Sub Progress Report Termin",
    child_MC : "Sub MC",
    child_BAPVA : "Sub BAPVA",
    child_RKTKA : "Sub RKTKA",
    child_MC_Addendum : "Sub MC Addendum",
    child_QC_Final : "Sub QC Final",
    child_BA_Delay : "Sub BA Delay",
    child_BA_Penalty : "Sub BA Penalty",
    child_BA_Final : "Sub BA Final",
    child_BA_Retensi : "Sub BA Retensi",
    project_qc_sipil : "Project QC Civil",
    project_qc_mekanikal : "Project QC Mechanical",
    project_qc_electrical : "Project QC Electrical",
    child_qc : "Sub QC Final",
    qc_electrical : "Project QC Electrical",
    qc_sipil : "Project QC Civil",
    qc_mekanikal : "Project QC Mechanical",
    creation_date : "Creation Date",
    edit_date : "Edit Date",
    deletion_date : "Deletion Date",
    summary_report : "Summary Report - Project Document",
    report_generate_date : "Report Generate Date",
    bastretensi : "BAST Retensi",
    rev_retensi : "Rev Retensi",
    project_manager : "Project Manager",
    progess_report : "Progress Report - Project Document",
    progess_report_wo : "Progress Report - Work Order",
    pic1 : "PIC 1",
    delay1 : "Delayed",
    pic2 : "PIC 2",
    delay2 : "Delayed",
    pic3 : "PIC 3",
    delay3 : "Delayed",
    pic4 : "PIC 4",
    delay4 :"Delayed",
    total_days : "Total Days",
    persentase_cut_off : "Deviation of Contract Value (%)",
    lead_engineer : "Lead Engineering",
    kom_qc : "Doc KOM QC",
    rev_kom_qc : "Rev KOM QC",
    progress : "Progress",
    inspection_no :"Inspection No",
    new_document : "New Document Total",
    project_coordinator : "Project Coordinator",
    penalty_days : "Penalty Day(s)",
    penalty_percentage : "Penalty Percentage/Day (‰)",
    total_penalty_value :"Total Penalty Value",
    max_penalty_value : "Max Penalty Value",
    total_penalty_charged : "Total Penalty Charged",
    log_date : "Log Date",
    id : "Item",
    Work_Group : "Work Group",
    Usrnm_Head_User : "Head User (Release)",
    Usrnm_Lead_Engineering : "Lead Engineering (Release)",
    Usrnm_Head_Project_Dept : "Head Project Department (Release)",
    Usrnm_PIC_Engineering_Closing : "PIC Engineering (Closing)",
    Usrnm_Head_User_Closing : "Head User (Closing)",
    Usrnm_Head_Project_Dept_Closing : "Head Project Department (Closing)",
    Work_Description : "Work Description",
    Target_Date : "Target Date",
    WBS_Allocation : "WBS Allocation",
    Usrnm_PM_Closing : "Project Manager (Closing)",
    HEAD_DEPT : "Head Department",
    LEAD_ENGINEERING : "Lead Engineering",
    HEAD_USER : "Head User",
    Approval_Wo : "Approval WO",
    Picture_Before : "Picture Before",
    download_before : "Download Before",
    Picture_After : "Picture After",
    download_after : "Download After",
    show_when_print : "Show When Print",
    Target_Reschedule : "Target Reschedule",
    Start_Work : "Start Work",
    Finish_Work : "Finish Work",
    requester : "Requester",
    Closed_Date : "Close Date", 
    Currency : "Currency",
    lock : "Lock",
    Contractor_Level : "Contractor Level",
    Administrator : "Administrator",
    Job_Role : "Job Role",
    is_main : "Main",
    Link_Main_Wo : "Link Main WO",
    main_data : "Main Data",
    Reason_Edit : "Reason to Edit",
    Change_History : "Log Changes",
    Is_Additional: "Addendum",
    Work_Order_Id : "Main WO",
    Doc_QC_Detail : "Inspections",
    Doc_QC_Inspection_Photos : "Inspections Photos",
    Doc_QC_Partcipants : "Partcipants",
    Work_Order : "Work Order",
    Work_Order_Detail : "Progressing",
    Doc_BA_Addendum : "BA Addendum",
    Doc_BA_Addendum_Reason : "BA Addendum Reason",
    Doc_BA_Addendum_Scope : "BA Addendum Scope",
    Doc_BA_Delay : "BA Delay",
    Doc_BA_Delay_Late : "BA Delay Late",
    Doc_BA_Final : "Doc BA Final",
    Doc_BA_Final_Evaluasi : "Doc BA Final Evaluasi",
    Doc_BA_Final_Progress : "Doc BA Final Progress",
    Doc_BA_Penalty : "Doc BA Penalty",
    Doc_BA_Penalty_Work : "Doc BA Penalty Work",
    Doc_BA_Retensi : "Doc BA Retensi",
    Doc_BA_Retensi_Evaluasi : "Doc BA Retensi Evaluasi",
    Doc_BA_Retensi_Progress : "Doc BA Retensi Progress",
    Doc_BA_Termin : "Doc BA Termin",
    Doc_BA_Termin_Evaluasi : "BA Termin Evaluasi",
    Doc_BA_Termin_Progress : "BA Termin Progress",
    Doc_BAIK : "BAIK With Out",
    Doc_BAIK_Reason : "BAIK With Out Reason",
    Doc_BAIK_Scope : "BAIK With Out Scope",
    Doc_BAIK_SPO : "BAIK With SPO",
    Doc_BAIK_SPO_Reason : "BAIK With SPO Reason",
    Doc_BAIK_SPO_Scope : "BAIK With SPO Scope",
    Doc_KOM : "Doc KOM",
    Doc_KOM_Company : "Doc KOM Company",
    Doc_KOM_Contractor : "Doc KOM Contractor",
    Doc_KOM_Item: "Doc KOM Item",
    Doc_KOM_QC : "Doc KOM QC",
    Main_Data : "Main Data",
    Status_Release : "Release Status",
    Release_Date : "Release Date",
    Progressing_Status : "Progressing Status",
    Doc_QC : "QC Final",
    Doc_QC_Detail : "QC Final Detail",
    
    Currency_Code : "Currency",
    Doc_Date : "Document Date",
    Tanggal_Mulai_Pekerjaan : "Job Start Date",
    Job_Role: "Job Role",
    Action_By : "Action By",
    Date_Action_Required : "Date Action Required",
    Sch_Date : "Sch Date",
    Act_Date : "Act Date",
    Tanggal_Penerimaan : "Received Date",
    Type_Persentase : "Percentage Type",
    Persentase_PP : "Additional/Deduction Percentage",
    Nilai_Akhir_Kontrak : "Final Contract Value",
    Type_Nilai : "Value Type",
    Date_Time : "Date Time",
    Username_Inspector : "Username Inspector",
    Username_QC_Mekanikal : "Project QC Mechanical",
    Username_QC_Electrical : "Project QC Electrical",
    Username_QC_Civil : "Project QC Civil",
    Inspection_Currently : "Inspection Currently",
    Inspection_Previosly : "Inspection Previously",
    Log_Date : "Log Date",
    Hari_Tanggal : "Document Date",
    Tanggal_Final : "QC Inspection FInal Date",
    Jumlah_Hari_Keterlambatan : "Number of Delay Days",
    Jumlah_Hari_Penalty : "Number of Penalty Days",
    Jumlah_Hari : "Number Of Days",
    Username_PM_PIC_Company : "PIC Project Manager",
    Tanggal_Mulai : "Start Date",
    Tanggal_Selesai : "End Date",
    Hari_Tanggal_Input : "Document Date",
    Rason : "Delay Reason",
    Penalty_Percentage : "Penalty Percentage",
    Total_Penalty_Value : "Total Penalty Value",
    Total_Penalty_Charged : "Total Penalty Charged ",
    Penalty_Days : "Penalty Days(s)",
    Rason : "Delay",
    Total_Days : "Total Days",
    Nilai_Kontrak : "Contract Value",
    Username_Project_Manager : "Project Manager",
    Currency_Code : "Currency",
    No_SPK : "No SPK",
    SPO_Date : "SPO Date",
    No_SPR	: "No SPR",
    No_SPO : "No SPO",
    summary_report_wo : "Summary Report - Work Order",
    Doc_No : "Doc No",

    Tanggal_Penerimaan : "Received Date",
    Username_PIC_PM : "Project Manager",
    Username_PIC_Contractor : "Project Manager Contractor",
    Meeting_No : "Meeting No",
    Issued_Date : "Issed Date",
    Meeting_Room : "Meeting Room",
    Date_Of_Meeting : "Date Of Meeting",
    Notes_Issued_By : "Notes Issued By",
    Approved_By : "Approved_By",
    Approved_Date : "Approved Date",
    next_process : "Next Process Document",
    status_document : "Status Document",
    Nilai_PP : "Value",
    Is_Check : "Check",
    Report_Number : "Report Number",
    Accept_Repair : "Accept Repair",
    Persentase_Cut_Off : "Cut Off In Progress (%)",
    Description_Discussions : "Description Discussions",
    Job_Start_Date : "Job Start Date",
    Planned_Start_Date : "Planned Start Date",
    Planned_Finish_Date : "Planned Finish Date",
    Act_Start_Date : "Act Start Date",
    Act_Finish_Date : "Act Finish Date",
    Migration_Data : "Migration Data",
    Usrnm_PIC_AR_Closing : "PIC Creator AR (Closing)",
    Usrnm_Lead_Engineering_Closing : "Lead Engineering (Closing)",
    Is_Tendering_Completed:"Tendering Completed",
    By_Engineering : "By Engineering",
    PIC_Engineering : "PIC Engineering",
    Usrnm_PM : "Project Manager",
    Usrnm_Prj_Coordinator : "Project Coordinator",
    Usrnm_Head_Unit : "Head Unit",
    Usrnm_Site_Manager : "Site Manager",
    Usrnm_Qc_Head : "QC Head",
    Usrnm_PM_Contractor : "Project Manager Contractor",
    AddScope : "Additional Scope",
    DeducationScope : "Deduction Scope",
    Sign_Position : "Sign Position",
    "PROJECT MANAGER CONTRACTOR": "Project Manager Contractor",
    'PROJECT MANAGER' : "Project Manager", 
    'PROJECT COORDINATOR' : "Project Coordinator",
    'SITE MANAGER' : "Site Manager", 
    'QC HEAD' : "QC Head", 
    'HEAD UNIT' : "Head unit",
    "QUANTITY SURVEYOR CONTRACTOR" : "Quantity Surveyor Contractor",
    "QUANTITY SURVEYOR" : "Quantity Surveyor",
    "ADMIN PROJECT" : "Admin Project",
    Work_Order_No : "Work Order No",
    WO_Type : "WO Type",
    Usrnm_Section_Head : "Section Head",
    Item_SPR : "Item SPR",
    Item_SPO : "Item SPO",
    Last_Pending_On : "Last Pending On",
    Valid_Date : "Valid Date",
    Name_Comp : "Company Name (Update)",
    Valid_From : "Valid From",
    UpdateWO : "Update Status WO",
    logprocess : "Log Process",
    Trigger_Code : "Trigger Code",
    Doc_Date_From : "From Date",
    required_field : "This field is required",
    Trigger_By : "Trigger By",
    Trigger_Date : "Trigger Date",
    JSON_Structure : "JSON Structure",
    document_name : "Document Name",
    Documentation : "Documentation",
    PIC_WO : "PIC Work Order",
    Duration : "Duration",
    Attachment : "Attachment",
    BoQ : "Bill of Quantity",
    material_price : "Material Price",
    labour_price : "Labour Price",
    initial_contract : "Initial Contract",
    MC0 : "MC-0",
    MC100 : "MC-100",
    MC_Between : "MC in Between",
    Volume : "Volume",
    Amount : "Amount",
    Deviasi : "Deviation",
    RKTK_MC0 : "RKTK MC-0",
    RKTK_MC_Between : "RKTK MC in Between",
    RKTK_MC100 : "RKTK MC-100",
    Contract_MC0 : "Contract Add MC-0",
    Contract_MC_Between : "Contract Add MC in Between",
    Contract_MC100 : "Contract Add MC-100",
    Total_Amount : "Total Amount",
    Final_Total_Amount : "Final Total Amount",
    Link_Work_Order : "Link Work Order",
    wo_type : "WO Type",
    wo_No : "WO No",
    link_mc : "Link From MC",
    SPO_No : "SPO No",
    SPO_Item : "SPO Item",
    Usrnm_Quantity_Surveyor : "Quantity Surveyor",
    Usrnm_QS_Contractor : "Quantity Surveyor Contractor",
    Usrnm_Admin_Project : "Admin Project",
    Usrnm_Project_Engineer : "Project Engineer",
    Usrnm_Factory_Manager : "Factory Manager",
    Usrnm_Operation_Head : "Operation Head",
    Usrnm_Site_PIC : "Site PIC",
    Total_Contract_Amount_BoQ : "Total Contract Amount (Base on Actual BoQ)",
    Total_Contract_Amount_SAP : "Total Contract Amount (Base on SAP)",
    Current_MC : "Current MC",
    Previous_MC : "Previous MC",
    volume : "Volume",
    Previous : "Previous",
    Current : "Current",
    Deviasi : "Deviation",
    BAPVA : "BAPVA",
    RKTKA : "RKTKA",
    ADDENDUM : "ADDENDUM",
    Addendum_MC : "Addendum MC",
    Total_Initial_Contract : "Total Initial Contract",
    Total_Actual_Contract : "Total Actual Contract",
    Rounding : "Rounding",
    Deviasi_Percent : "Deviation(%)",
    unit_price : "Unit Price",
    Material : "Material",
    Labour : "Labour",
    Final_Contract_Amount : "Final Contract Amount",
    Total_Previous_Progress : "Progress Previous Total (%)",
    Total_Current_Progress : "Progress Current Total (%)",
    Total_To_Date_Progress : "Progress To Date (%)",
    Progress_To_Charge : "Progress To Charge (%)",
    progress_previous : "Progress Previous",
    progress_current : "Progress Current",
    progress_to_date : "Progress To Date",
    MC_Number : "Link MC",
    New_SPO : "New SPO",
    parent : "Parent",
    Pur_Org : "Purchase Organization",
    Document_Name : "Document Name",
    Active_SAP : "Active SAP",
    Adopt_SAP : "Adopt SAP",
    MC : "MC",
    RKTK : "RKTK",
    BAPVA : "BAPVA",
    Progress_Termin : "Progress Termin",
    Progress_Final : "Progress Final",
    Wo_Creation : "Work Order Creation",
    Wo_Closing : "Work Order Closing",
    Invoice_No : "Contractor Invoice No",
    Status_Payment : "Payment Status",
    MC0_STATUS : "MC-0",
    MC_BETWEEN_STATUS : "MC-Between",
    MC100_STATUS : "MC-100",
    BAPVA_MC0_STATUS : "BAPVA MC-0",
    BAPVA_MC_BETWEEN_STATUS : "BAPVA MC-Between",
    BAPVA_MC100_STATUS : "BAPVA MC-100",
    RKTK_MC0_STATUS : "RKTK MC-0",
    RKTK_MC_BETWEEN_STATUS : "RKTK MC-Between",
    RKTK_MC100_STATUS : "RKTK MC-100",
    ADDENDUM_MC0_STATUS : "ADDENDUM MC-0",
    ADDENDUM_MC_BETWEEN_STATUS : "ADDENDUM MC-Between",
    ADDENDUM_MC100_STATUS : "ADDENDUM MC-100",
    PROGRESS_TERMIN_STATUS : "PROGRESS TERMIN",
    PROGRESS_FINAL_STATUS : "PROGRESS FINAL",
    rev_MC0 : "Rev MC-0",
    rev_MC_BETWEEN : "Rev MC Between",
    rev_MC100 : "Rev MC-100",
    rev_BAPVA_MC0 : "Rev BAPVA MC-0",
    rev_BAPVA_MC_BETWEEN : "Rev BAPVA MC Between",
    rev_BAPVA_MC100 : "Rev BAPVA MC-100",
    rev_RKTK_MC0 : "Rev RKTK MC-0",
    rev_RKTK_MC_BETWEEN : "Rev RKTK MC Between",
    rev_RKTK_MC100 : "Rev RKTK MC-100",
    rev_ADDENDUM_MC0 : "Rev ADDENDUM MC-0",
    rev_ADDENDUM_MC_BETWEEN : "Rev ADDENDUM MC Between",
    rev_ADDENDUM_MC100 : "Rev ADDENDUM MC-100",
    rev_PROGRESS_TERMIN : "Rev PROGRESS TERMIN",
    rev_PROGRESS_FINAL : "Rev PROGRESS FINAL",
    date_mc : "Date of MC",
    verification_date : "Verification Date",
    phone_number : "Phone Number",
    contact_person : "Contact Person",
    not_viewed : "Not Viewed",
    Deleted : "Delete",
    contract : "Contract",
    amount : "Amount",
    modul : "Module",
    Contract_Amount_New_SPO : "Contract Amount for New SPO",
    Contract_Amount_Initial_SPO : "Contract Amount for Initial SPO",
    Contract_Adjust : "Lastest Contract (for Adjust Price)",
    Calculate : "Calculate",
    Contract_Amount : "Contract Amount",
    SPO_Category_Type : "SPO Category No",
    code_contractor : "Contractor Code",
    only_draft : "Only Draft",
    Initial_Instruction : "Initial Instruction",
    Instruction_BaseMC : "Instruction Base on MC",
    message:{
        reset_confirmation: "Do you want to reset appraisal data",
        revised_confirmation: "Do you want to REVISE this data",
        approve_confirmation: "Do you want to APPROVE this data",
        reject_confirmation: "Do you want to REJECT this data",        
        sync_confirmation: "Are you sure ? These selected appraisal(s) data will be sync to SAP HCM",
        sync_all_confirmation: "Are you sure to sync all appraisal data ?"        
    },

    
    note: {
        history: "Note : Assessor data is sorted from bottom to top (the topmost data is the most recent data). Can be seen from the date and time in the column 'Input Date'",
        mydata: "Note : The green line is an employee whose evaluation has been assessed by the committee",
        listAssed: "Note for Admin Unit : For employee assessments that have been edited or uploaded by the Admin HO, there is no longer an edit button in the employee column",
        employee: "Note : Employees displayed are employees who are not in (PHK, Termination & Expatriate), join above or past 1-July-Year, and grade 10 i.e. director",
        reset: "Note : The data that is reset is the last assessment data !",
        cancel_promot: "If you cancel this promotion request, you can still request it again at SAP Fiori",
        upload: " may be duplicated and new code may be entered. If the code already exists (duplicate), then the previous data will be updated"
    },

    acceptpekerjaan : {
        menerima : "Menerima, pekerjaan telah dilaksanakan sesuai dengan instruksi dari pelaksana project",
        tidak_menerima : "Tidak bisa menerima, kontraktor harus membongkar dan atau memperbaiki dalam waktu 2 (dua) minggu"
    },

    messagebox:{
        cutoff : "Please input the progress percentage at the time of cut off"
    }
}

export default message;